import { Component, OnInit } from '@angular/core';
import { CrudService } from '../../../crud/crud.service';

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';

@Component({
  selector: "app-horario-lista",
  templateUrl: "./lista.component.html"
})
export class ListaComponent implements OnInit {
  tamano = document.body.clientHeight;
  detalles: any = "";
  grupos = [];
  turnos = [];
  profesores_horarios = [];
  profesorhorario;
  ph_modulos = [];
  ph_dias = [];
  ph_horas = [];

  logo_sucursal = "";
  logo_empresa = "";
  logo_carrera = "";
  cargando = false;
  imprimirhorario = false;
  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  constructor(private crudService: CrudService) { }

  ngOnInit() {
  }

  generarPDFTabla(arrays) {
    if (
      this.profesorhorario.modalidades.modalidades_dias.length > 2
    ) {
      this.generarPDFTablaEscolarizado(arrays);
    } else {
      this.generarPDFTablaSemiEscolarizado(arrays);
    }
  }

  generarPDFTablaEscolarizado(arrays) {
    let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");

    let doc = new jsPDF("landscape", "mm", "letter");

    let periodos_escolares = arrays.modulos_periodos_escolares;

    this.ph_modulos.forEach((modulo, i) => {
      let logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
      if (logo != "")
        doc.addImage(logo, "PNG", 10, 5, 26, 26, "", "FAST");

      if (this.logo_carrera != "")
        doc.addImage(this.logo_carrera, "PNG", 210, 5, 26, 26, "", "FAST");
      //Nombre empresa
      doc.setFontSize(15);
      doc.setFont("helvetica", "", "bold");
      doc.setFont("helvetica");
      doc.text(this.configuracion.empresa.nombre, 140, 12, { align: "center" });

      doc.setFontSize(14);
      doc.setFont("helvetica", "", "bold");
      doc.text(this.configuracion.empresa.subnombre, 140, 18, { align: "center" });

      doc.setFontSize(10);
      doc.setFont("helvetica", "", "normal");
      doc.text("Campus: " + this.configuracion.sucursal.nombre, 145, 24, { align: "center" });

      doc.setFontSize(10);
      doc.setFont("helvetica", "", "bold");
      doc.text("HORARIO DE GRUPO", 138, 30, { align: "center" });

      doc.setFontSize(8);
      doc.setFont("helvetica", "", "bold");
      doc.text(
        "Periodo: " +
        this.profesorhorario.periodos_escolares.nombre +
        " Carrera: " +
        this.profesorhorario.carreras_planes.carreras.nombre,
        145,
        35,
        { align: "center" }
      );
      doc.text(
        " Grupo: " +
        this.profesorhorario.grupos.clave + ' ' + this.profesorhorario.grupos.nivel + ' ' + this.profesorhorario.grupos.identificador +
        " Modalidad: " +
        this.profesorhorario.modalidades.nombre +
        " Turno: " +
        this.profesorhorario.turnos.nombre +
        " (" +
        modulo.nombre +
        " - del " +
        modulo.fecha_inicio +
        " a " +
        modulo.fecha_fin +
        ")",
        145,
        40,

        { align: "center" }
      );

      let res = (doc as any).autoTableHtmlToJson(
        document.getElementById("tablahorario" + i)
      );

      (doc as any).autoTable(res.columns, res.data, {
        didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
          cell.styles.fillColor = "#ffffff";
        },
        startY: 50,
        styles: {
          fontSize: 6, font: "helvetica",
          halign: "center",
          fillColor: "#FFFFFF",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        bodyStyles: {
          overflow: 'linebreak',
          cellPadding: 0.8
        },
        theme: "grid",
        margin: { right: 10, left: 10 },
        columnStyles: {
          0: { cellWidth: 20 }
        }
      });

      let lineas = 45 + res.data.length * 18;

      let columns = [
        { title: "Parcial", dataKey: "id" },
        { title: "Fecha de inicio", dataKey: "inicio" },
        { title: "Fecha de termino", dataKey: "termino" }
      ];
      let rows = [];
      periodos_escolares[i].periodos_escolares_parciales.forEach(par => {
        rows.push({
          id: par.numero_parcial,
          inicio: par.fecha_inicio,
          termino: par.fecha_fin
        });
      });

      (doc as any).autoTable({
            columns:columns, 
            body: rows,
        didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
          cell.styles.fillColor = "#ffffff";
        },
        startY: lineas,
        styles: {
          fontSize: 6, font: "helvetica",
          halign: "center",
          fillColor: "#FFFFFF",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        bodyStyles: {
          overflow: 'linebreak',
          cellPadding: 0.8
        },
        theme: "grid",
        margin: { right: 10, left: 10 },
        columnStyles: {
          0: { cellWidth: 20 }
        }
      });
      lineas += rows.length * 7;

      doc.setFont("courier");
      doc.setFontSize(6);

      if (arrays.periodos_escolares.nota_alumnos) {
        arrays.periodos_escolares.nota_alumnos = arrays.periodos_escolares.nota_alumnos.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
        
        doc.fromHTML(arrays.periodos_escolares.nota_alumnos, 10, lineas + 5, {
          width: 530
        });
      }

      if (i < this.ph_modulos.length - 1) doc.addPage();
    });

    // doc.autoPrint();
    //const string = (doc as any).output("datauristring", "horario_docente.pdf");
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe =
      "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
      string +
      "'></iframe>";

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  generarPDFTablaSemiEscolarizado(arrays) {
    let color = $(".hero.is-primary").css("background-color");

    let doc = new jsPDF("landscape", "mm", "letter");

    let periodos_escolares = arrays.modulos_periodos_escolares;

    let logo =
      this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
    if (logo != "")
      doc.addImage(logo, "PNG", 10, 5, 26, 26, "", "FAST");

    if (this.logo_carrera != "")
      doc.addImage(this.logo_carrera, "PNG", 210, 5, 26, 26, "", "FAST");
    //Nombre empresa
    doc.setFontSize(15);
    doc.setFont("helvetica", "", "bold");
    doc.setFont("helvetica");
    doc.text(this.configuracion.empresa.nombre,140, 12,  {align:"center"});

    doc.setFontSize(14);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.empresa.subnombre,140, 18,  {align:"center"});

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "normal");
    doc.text(
      "Campus: " + this.configuracion.sucursal.nombre,
      145,
      24,
      {align:"center"}
    );

    doc.setFontSize(10);
    doc.setFont("helvetica", "", "bold");
    doc.text("HORARIO DE GRUPO", 138, 30, {align:"center"});

    doc.setFontSize(8);
    doc.setFont("helvetica", "", "bold");
    doc.text(
      "Periodo: " +
      this.profesorhorario.periodos_escolares.nombre +
      " Carrera: " +
      this.profesorhorario.carreras_planes.carreras.nombre,
      145,
      35,
      {align:"center"}
    );
    doc.text(
      " Grupo: " +
      this.profesorhorario.grupos.clave + ' ' + this.profesorhorario.grupos.nivel + ' ' + this.profesorhorario.grupos.identificador +
      " Modalidad: " +
      this.profesorhorario.modalidades.nombre +
      " Turno: " +
      this.profesorhorario.turnos.nombre,
      145,
      40,
      {align:"center"}
    );
    let lineas = 45;

    let submodulos = []; let total = 0; let subtotal = 0;
    this.ph_modulos.forEach(modulo => {
      if (typeof submodulos[subtotal] == 'undefined')
        submodulos[subtotal] = [];
      submodulos[subtotal].push(modulo);
      if (total == 2) {
        total = -1;
        subtotal++;
      }
      total++;
    });

    submodulos.forEach(mod => {
      let columns = [];
      this.ph_dias.forEach(dia => {
        columns.push({
          title: dia,
          dataKey: dia
        });
      });

      (doc as any).autoTable(columns, [], {
        didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
          cell.styles.fillColor = "#ffffff";
        },
        startY: lineas,
        styles: {
          fontSize: 6, font: "helvetica",
          halign: "center",
          fillColor: "#FFFFFF",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        bodyStyles: {
          overflow: 'linebreak',
          cellPadding: 0.8
        },
        theme: "grid",
        margin: { right: 10, left: 10 },
        columnStyles: {
          0: { cellWidth: 20 },
          1: { cellWidth: 60 }
        }
      });

      lineas += 6;
      columns = [{ title: "Hora", dataKey: "hora" }];

      mod.forEach(modulo => {
        columns.push({
          title: modulo,
          dataKey: modulo
        });
      });

      let rows = [];

      this.ph_horas.forEach(hora => {
        rows.push({});
        this.ph_dias.forEach(dia => {
          mod.forEach(modulo => {
            rows[rows.length - 1]["hora"] = hora;
            rows[rows.length - 1][modulo] = this.profesorhorario.horario[modulo][dia][hora] ? (this.profesorhorario.horario[modulo][dia][hora].nombre + '\n' + this.profesorhorario.horario[modulo][dia][hora].clave + '\n' + this.profesorhorario.horario[modulo][dia][hora].docente) : "";
          });
        });
      });

      (doc as any).autoTable({
            columns:columns, 
            body: rows,
        didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
          cell.styles.fillColor = "#ffffff";
        },
        startY: lineas,
        styles: {
          fontSize: 6, font: "helvetica",
          halign: "center",
          fillColor: "#FFFFFF",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        bodyStyles: {
          overflow: 'linebreak',
          cellPadding: 0.8
        },
        theme: "grid",
        margin: { right: 10, left: 10 },
      });
      lineas += this.ph_horas.length * 16 + 8;
    });

    this.ph_modulos.forEach((modulo, i) => {
      let columns = [
        { title: "Parcial", dataKey: "id" },
        { title: "Fecha de inicio", dataKey: "inicio" },
        { title: "Fecha de termino", dataKey: "termino" }
      ];
      let rows = [];

      periodos_escolares[i].periodos_escolares_parciales.forEach(par => {
        rows.push({
          id: par.numero_parcial,
          inicio: par.fecha_inicio,
          termino: par.fecha_fin
        });
      });

      (doc as any).autoTable({
            columns:columns, 
            body: rows,
        didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
          cell.styles.fillColor = "#ffffff";
        },
        startY: lineas,
        styles: {
          fontSize: 6, font: "helvetica",
          halign: "center",
          fillColor: "#FFFFFF",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        bodyStyles: {
          overflow: 'linebreak',
          cellPadding: 0.8
        },
        theme: "grid",
        margin: { right: 10, left: 10 },
        columnStyles: {
          0: { cellWidth: 20 }
        }
      });
      lineas += rows.length * 6 + 6;
    });

    doc.setFont("courier");
    doc.setFontSize(6);

    if (arrays.periodos_escolares.nota_alumnos) {
      lineas += 10;
      arrays.periodos_escolares.nota_alumnos = arrays.periodos_escolares.nota_alumnos.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
      
      doc.fromHTML(arrays.periodos_escolares.nota_alumnos, 10, lineas + 5, {
        width: 530
      });
    }

    // doc.autoPrint();
    //const string = (doc as any).output("datauristring", "horario_docente.pdf");
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe =
      "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
      string +
      "'></iframe>";

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  generarPDF(arrays) {
    this.imprimirhorario = true;
    let ph_horas = [];
    let ph_dias = [];
    let ph_modulos = [];
    this.cargando = true;
    this.profesorhorario = arrays;

    this.profesorhorario.horario = [];
    this.profesorhorario.modulos_periodos_escolares.forEach(element => {
      let elmodulo = element.fecha_inicio + " al " + element.fecha_fin;
      ph_modulos.push(elmodulo);
      if (typeof this.profesorhorario.horario[elmodulo] == "undefined")
        this.profesorhorario.horario[elmodulo] = [];

      element.horarios_dias.forEach(elem => {
        ph_dias.push(elem.dias_semanas.nombre);
        if (typeof this.profesorhorario.horario[elmodulo][elem.dias_semanas.nombre] == "undefined")
          this.profesorhorario.horario[elmodulo][elem.dias_semanas.nombre] = [];

        elem.horarios_detalles.forEach(el => {
          let elhora = el.hora_inicio + "-" + el.hora_termino;
          if (typeof this.profesorhorario.horario[elmodulo][elem.dias_semanas.nombre][elhora] == "undefined")
            this.profesorhorario.horario[elmodulo][elem.dias_semanas.nombre][elhora] = null;
          this.profesorhorario.horario[elmodulo][elem.dias_semanas.nombre][elhora] = {
            nombre: el.materias.nombre,
            clave: el.materias.clave,
            docente: el.personas ? el.personas.nombre : ''
          };
          ph_horas.push(elhora);
        });
      });
    });

    this.ph_horas = this.arrayUnico(ph_horas);
    this.ph_dias = this.arrayUnico(ph_dias);
    this.ph_modulos = this.arrayUnico(ph_modulos);

    setTimeout(() => {
      this.cargando = false;
      this.generarPDFTabla(arrays);
    }, 200);
  }

  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo_carrera = logos.carrera;
    }
  }

  arrayUnico(array) {
    return array.filter(function (valor, indiceActual, arreglo) {
      let indiceAlBuscar = arreglo.indexOf(valor);
      if (indiceActual === indiceAlBuscar) {
        return true;
      } else {
        return false;
      }
    });
  }
}
